export default {
  sortedAgents: state => {
    return state.agents.data.sort(function (a, b) {
      let nameA = `${a.prenom} ${a.nom}`
      let nameB = `${b.prenom} ${b.nom}`
      return nameA.localeCompare(nameB)
    })
  },
  sortedListAgents: state => {
    return state.agents.list.sort(function (a, b) {
      let nameA = `${a.prenom} ${a.nom}`
      let nameB = `${b.prenom} ${b.nom}`
      return nameA.localeCompare(nameB)
    })
  },
  getShowProfilDiv: state => {
    return state.showProfilDiv
  },
}



// WEBPACK FOOTER //
// ./src/store/getters.js